import addDate from './addDate';

export default function getCalendarRanges (maxDaysSearch) {
  const today = new Date();
  const maxDate = addDate(new Date(), maxDaysSearch);
  const min = [today.getFullYear(), today.getMonth(), today.getDate()];
  const max = [maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate()];
  return { min, max };
}
